module.exports = __webpack_public_path__ + "static/media/039-backspace.4b37d7ee.svg";